module.exports = __webpack_public_path__ + "img/osi.c6e39bde.svg";